import actions from '../../actionTypes';

export default (email, token, password) => {
  return {
    type: actions.RESET_PASSWORD,
    email,
    token,
    password
  };
};



// WEBPACK FOOTER //
// ./src/reducers/auth/actions/resetPassword.js